import { render, staticRenderFns } from "./TikQAlignment.vue?vue&type=template&id=838a3ad0&scoped=true&"
import script from "./TikQAlignment.vue?vue&type=script&lang=js&"
export * from "./TikQAlignment.vue?vue&type=script&lang=js&"
import style0 from "./TikQAlignment.vue?vue&type=style&index=0&id=838a3ad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838a3ad0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
